<template>
    <div class="scan-edit-page scrollable">
        <div class="page-header">
            <h1>{{ $route.meta.title }}</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'scans' }">
                    Scans
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="edit-form">
          <report-show :report-data="reportData" :report-info="reportInfo"/>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import ReportShow from '../../../components/UsersList/UserEdite/ReportShow'

  export default {
    name: 'ScanView',
    components: {
      ReportShow,
    },
    data () {
      return {
        urlRequest: '',

      }
    },
    computed: {
      ...mapGetters({
        reportData: 'scans/reportData',
        reportInfo: 'scans/reportInfo',
        scanData: 'scans/getScanShow',
      }),

    },
    created () {
      if (this.$route.params.id) {
        this.$store.dispatch('scans/scanShow', this.$route.params.id)

      }
    },
    methods: {

    },
  }
</script>

<style lang="scss">
    .upload-image {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
        display: flex;
        align-items: center;
        justify-content: center;
        input[type=file] {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 10;
            opacity: 0;
            cursor: pointer;
        }
        i[class^="el-icon-"] {
            position: absolute;
            z-index: 1;
            font-size: 2em;
        }
        img {
            position: absolute;
            object-fit: cover;
            z-index: 9;
        }
    }

    .upload-image:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .cust-box {
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        min-height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;

    }

    .upload-image-create {
        position: relative;
        cursor: pointer;
        input[type="file"] {
            cursor: pointer;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
        }
    }

    .file-name {
        padding: 0 10px;
    }

    .err-class {
        border-color: #ec205f;
    }

    .el-form-item__error{
        bottom: -5px;
    }
</style>
